import { eventChannel, SagaIterator } from 'redux-saga';
import { delay, race, take } from 'redux-saga/effects';
import { ResultsMap } from '../../types';

export const ONLINE_WAIT_MS = 60_000;

// Prefer non-standard `navigator.isOnline` when present, otherwise fall back
// to the standard `navigator.onLine`.
export const isNavigatorOnline = (): boolean => {
  const nav: any = typeof navigator !== 'undefined' ? (navigator as any) : undefined;

  return Boolean(nav?.isOnline ?? nav?.onLine);
};

export const createOnlineChannel = () =>
  eventChannel<boolean>((emit) => {
    const handler = () => emit(true);
    if (typeof window !== 'undefined') {
      window.addEventListener('online', handler);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('online', handler);
      }
    };
  });

// Wait up to ONLINE_WAIT_MS for `online`; returns false if still offline.
export function* waitForOnline(label: string): SagaIterator<boolean> {
  if (isNavigatorOnline()) return true;
  console.log(`[${label}] offline, waiting up to ${ONLINE_WAIT_MS}ms`);
  const onlineChannel = createOnlineChannel();
  try {
    yield race({ online: take(onlineChannel), timeout: delay(ONLINE_WAIT_MS) });
  } finally {
    onlineChannel.close();
  }
  if (!isNavigatorOnline()) {
    console.warn(`[${label}] still offline after wait, aborting`);

    return false;
  }

  return true;
}

export const countFullyDone = (results: ResultsMap): number => {
  let n = 0;
  results.forEach((v) => {
    if (v === null) n++;
  });

  return n;
};

export const countCompressPending = (results: ResultsMap): number => {
  let n = 0;
  results.forEach((v) => {
    if (v !== null) n++;
  });

  return n;
};
